import { createTheme, colors } from '@material-ui/core';
import shadows from './shadows';
import typography from './typography';
import breakpoints from './breakpoints';

const theme = createTheme({
  palette: {
    background: {
      dark: '#F4F6F8',
      default: colors.common.white,
      paper: colors.common.white,
    },
    primary: {
      main: colors.grey[900],
    },
    secondary: {
      main: colors.blue[500],
    },
    text: {
      primary: colors.blueGrey[900],
      secondary: colors.blueGrey[600],
    },
  },
  shadows,
  typography,
  breakpoints,
});

export default theme;
